import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { useColonyBrand } from "@/pages/colony/useColonyBrand";
import "@/styles/management.css";

export const OnboardingShell = ({ title, children }) => {
  useColonyBrand();
  return <main className="management-skin min-h-screen bg-slate-50" data-testid="management-onboarding">
    <header className="relative overflow-hidden border-b border-slate-200">
      <img src="/images/bungalow-colony-hero.jpg" alt="Bungalow colony" className="absolute inset-0 h-full w-full object-cover object-center" />
      <div className="absolute inset-0 bg-emerald-950/70" />
      <div className="relative max-w-4xl mx-auto px-5 py-9 sm:py-12 text-white"><Link to="/managementusa" className="inline-flex items-center gap-2 text-sm font-semibold" data-testid="onboarding-home"><Home className="h-5 w-5" />Management USA NJ</Link><h1 className="font-display text-3xl sm:text-4xl font-bold mt-6" data-testid="onboarding-title">{title}</h1></div>
    </header>
    <section className="max-w-xl mx-auto px-5 py-8 sm:py-10">{children}<Link to="/managementusa" className="inline-flex items-center gap-2 text-sm text-muted-foreground mt-7 hover:text-foreground" data-testid="onboarding-back"><ArrowLeft className="h-4 w-4" />Back to sign in</Link></section>
  </main>;
};